<div class="mbs-select">
  @if (label) {
    <mbs-input-label
      [boldLabel]="boldLabel"
      [disabled]="disabledState"
      [hasDescription]="!!description"
      [id]="id"
      [info]="info"
      [infoContainer]="infoContainer"
      [infoPlacement]="infoPlacement"
      [infoTriggers]="infoTriggers"
      [label]="label"
      [labelClasses]="labelClasses"
      [labelPosition]="labelPosition"
      [labelSize]="labelSize"
      [required]="hasRequiredValidator && showRequiredMark" />
  }

  @if (description) {
    <div class="text-sm text-gray-600 mb-1">
      <ng-container [ngTemplateOutlet]="description" />
    </div>
  }

  <ng-select
    class="mbs-select_ng-select"
    [addTag]="addTag"
    [addTagText]="addTagText"
    [appearance]="appearance"
    [appendTo]="resolvedAppendTo"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [clearable]="clearable"
    [clearAllText]="clearAllText"
    [clearOnBackspace]="clearOnBackspace && !isCounterShowing"
    [clearSearchOnAdd]="clearSearchOnAdd"
    [closeOnSelect]="!isCheckboxSelect && closeOnSelect"
    [compareWith]="compareWith"
    [dropdownPosition]="dropdownPosition"
    [formControl]="formControlSelect"
    [groupBy]="groupBy"
    [hideSelected]="hideSelected"
    [id]="id"
    [isOpen]="isOpen"
    [items]="items"
    [labelForId]="id"
    [loading]="loading"
    [loadingText]="loadingText"
    [markFirst]="markFirst"
    [maxSelectedItems]="maxSelectedItems"
    [multiple]="multiple"
    [ngClass]="ngSelectClasses"
    [notFoundText]="notFoundText"
    [placeholder]="placeholder"
    [readonly]="disabledState"
    [searchable]="searchable"
    [searchFn]="searchFn"
    [selectableGroup]="selectableGroup"
    [selectableGroupAsModel]="selectableGroupAsModel"
    [typeahead]="typeahead"
    [typeToSearchText]="typeToSearchText"
    [virtualScroll]="virtualScroll"
    (add)="addEvent.emit($event)"
    (blur)="blurEvent.emit($event)"
    (change)="ngSelectChangeHandler($event)"
    (clear)="clearEvent.emit($event)"
    (close)="handleClose($event)"
    (focus)="focusEvent.emit($event)"
    (open)="handleOpen()"
    (remove)="removeEvent.emit($event)"
    (scroll)="scroll.emit($event)"
    (scrollToEnd)="scrollToEnd.emit()"
    (search)="onSearch($event)">
    @if (mbsSelectMultiLabelTmp) {
      <ng-template
        let-clear="clear"
        let-items="items"
        ng-multi-label-tmp>
        <ng-container
          [ngTemplateOutlet]="mbsSelectMultiLabelTmp"
          [ngTemplateOutletContext]="{ items, clear }" />
      </ng-template>
    } @else if (isCounterShowing) {
      <ng-template
        let-clear="clear"
        let-items="items"
        ng-multi-label-tmp>
        <div
          class="counter inline-block fw-semibold px-1 rounded d-flex align-items-center justify-content-center"
          style="background-color: var(--mbs-primary); color: var(--mbs-bg)">
          {{ items?.length }}
        </div>
        <span class="counter-label">
          {{ labelForCounter }}
        </span>
      </ng-template>
    }

    @if (mbsSelectFooterTmp) {
      <ng-template ng-footer-tmp>
        <ng-container [ngTemplateOutlet]="mbsSelectFooterTmp" />
      </ng-template>
    }

    @if (mbsSelectLabelTmp) {
      <ng-template
        let-item="item"
        ng-label-tmp>
        <ng-container
          [ngTemplateOutlet]="mbsSelectLabelTmp"
          [ngTemplateOutletContext]="{ item }" />
      </ng-template>
    }

    @if (mbsSelectOptionTmp) {
      <ng-template
        let-index="index"
        let-item="item"
        let-item$="item$"
        ng-option-tmp>
        <ng-container
          [ngTemplateOutlet]="mbsSelectOptionTmp"
          [ngTemplateOutletContext]="{ item, index, item$ }" />
      </ng-template>
    }

    @if (mbsSelectOptGroupTmp) {
      <ng-template
        let-index="index"
        let-item="item"
        let-item$="item$"
        ng-optgroup-tmp>
        <ng-container
          [ngTemplateOutlet]="mbsSelectOptGroupTmp"
          [ngTemplateOutletContext]="{ item, index, item$ }" />
      </ng-template>
    }

    @if (mbsSelectHeaderTmp) {
      <ng-template
        let-index="index"
        let-item="item"
        let-item$="item$"
        ng-header-tmp>
        <ng-container
          [ngTemplateOutlet]="mbsSelectHeaderTmp"
          [ngTemplateOutletContext]="{ item, index, item$ }" />
      </ng-template>
    }

    @if (mbsSelectNotFoundTmp) {
      <ng-template
        let-index="index"
        let-item="item"
        let-item$="item$"
        ng-notfound-tmp>
        <ng-container
          [ngTemplateOutlet]="mbsSelectNotFoundTmp"
          [ngTemplateOutletContext]="{ item, index, item$ }" />
      </ng-template>
    }

    @if (ngOptions) {
      @for (option of ngOptions; track option) {
        {{ option }}
      }
    }

    @if (isCheckboxSelect) {
      <ng-template
        let-index="index"
        let-item="item"
        let-item$="item$"
        ng-option-tmp>
        <mbs-checkbox
          [checked]="item$.selected"
          [id]="item[bindLabel]"
          [label]="item[bindLabel]"
          [labelClasses]="isCheckboxOverflow ? 'text-overflow' : ''"
          [labelContentClasses]="isCheckboxOverflow ? 'text-overflow' : ''"
          (click)="$event.preventDefault()" />
      </ng-template>
    }

    <ng-template
      let-item="item"
      let-item$="item$"
      ng-optgroup-tmp>
      <mbs-checkbox
        [id]="item.groupBy"
        [indeterminate]="isSomeItemsSelected(item$) && !item$.selected"
        [label]="item.groupBy"
        [labelClasses]="isCheckboxOverflow ? 'text-overflow' : ''"
        [labelContentClasses]="isCheckboxOverflow ? 'text-overflow' : ''"
        [ngModel]="item$.selected"
        [ngModelOptions]="{ standalone: true }"
        [style.pointer-events]="'none'" />
    </ng-template>
  </ng-select>

  @if (hint) {
    <div class="mt-1 text-sm text-gray-600">
      <ng-container [ngTemplateOutlet]="hint" />
    </div>
  }

  <mbs-input-errors [errors]="errors" />
</div>
